import $ from "jquery";
import moment from "moment";
import Vue from "vue";
import Component from "vue-class-component";
import { AbsenceSalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { EtatAbsencesEnum } from "../../../dto/GenApi.iNotPaie.Dto/EtatAbsencesEnum";
import DataTestIDHelper from "../../../Helper/DataTestID/DataTestIDHelper";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";

@Component({
	components: {
		ModalAlerteAbsenceCalculeeComponent: require("../modalAlerteAbsenceCalculee/modalAlerteAbsenceCalculee.vue.html")
	}
})
export default class ModalSuppressionAbsenceImposeeDate extends Vue {
	public dataReady = false;
	public absences: AbsenceSalarieDto[] = [];

	public init(): void {
		this.fetchData();
	}

	public fetchData(): void {
		this.dataReady = false;
		ServicesFactoryInstance.AbsencesService.getAbsencesSalarieImposees(data => {
			this.absences = data;
			this.dataReady = true;
		}, () => {
			this.dataReady = true;
		});
	}

	public formatDate(date: Date): string {
		return moment.utc(String(date)).format("DD / MM / YYYY");
	}

	public select(absence: AbsenceSalarieDto): void {
		// Si une absence est déjà calculée, il faut notifier l'utilisateur.
		if (absence.Etat == EtatAbsencesEnum.Calcule) {
			$("#modalSuppressionAbsenceImposeeDate").modal("hide");
			this.$emit("annulationAbsenceCalculee", absence);
		} else {
			this.$emit("enregistrementOk", absence);
		}
	}

	public cancel(): void {
		$("#modalSuppressionAbsenceImposeeDate").modal("hide");
	}

	public getAbsenceCollectiveSelectEntryButtonDataTestId(absence: AbsenceSalarieDto, suffix: string): string {
		return DataTestIDHelper.getAbsenceRequestDataTestID(absence.LibelleTypeAbsence, absence.DateDebut, absence.DateFin, "planningAbsence-absenceCollective-", suffix);
	}
}



// WEBPACK FOOTER //
// ./src/components/planningAbsences/modalSuppressionAbsenceImposeeDate/modalSuppressionAbsenceImposeeDate.ts